import { SdsHazardPickerComponent } from './components/sds-hazard-picker.component';
import { SdsBulkImportComponent } from './components/sds-bulk-import.component';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

import { SdsComponent } from './sds.component';
import { SdsListComponent } from './components/sds-list.component';
import { SdsNewComponent } from './components/sds-new.component';
import { SdsDetailComponent } from './components/sds-detail.component';
import { SdsPublicPreviewComponent } from './components/sds-public-preview.component';
import { SdsPublicListComponent } from './components/sds-public-list.component';
import { SdsListQrComponent } from './components/sds-list-qr.component';
import { SdsExposureRegisterComponent } from './components/sds-exposure-register.component';
import { SdsArchivePickerComponent } from './components/sds-archive-picker.component';
import { SdsSubstitutionAssessmentComponent } from './components/sds-substitution-assessment.component';
import { SdsLegalReferenceComponent } from './components/sds-legal-reference.component';
import { AppSharedModule } from './../shared/appShared.module';
import { ArchiveServices } from '../archive/archive.services';

import { StepperModule } from 'primeng/stepper';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MenuModule } from 'primeng/menu';
import { QRCodeComponent } from 'angularx-qrcode';

@NgModule({
  imports: [IconFieldModule, InputIconModule, InputTextModule, 
    CommonModule,
    SdsHazardPickerComponent,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslatePipe, TranslateDirective,
    AppSharedModule,
    StepperModule,
    FileUploadModule,
    DialogModule,
    ProgressBarModule,
    ToggleSwitchModule,
    TableModule,
    DatePickerModule,
    SelectModule,
    TooltipModule,
    AutoCompleteModule,
    MenuModule,
    QRCodeComponent
  ],
  exports: [
    SdsComponent,
    SdsListComponent,
    SdsNewComponent,
    SdsDetailComponent,
    SdsPublicPreviewComponent,
    SdsPublicListComponent,
    SdsExposureRegisterComponent
  ],
  declarations: [
    SdsBulkImportComponent,
    SdsComponent,
    SdsListComponent,
    SdsNewComponent,
    SdsDetailComponent,
    SdsPublicPreviewComponent,
    SdsPublicListComponent,
    SdsListQrComponent,
    SdsExposureRegisterComponent,
    SdsArchivePickerComponent,
    SdsSubstitutionAssessmentComponent,
    SdsLegalReferenceComponent
  ],
  providers: [ArchiveServices]
})
export class SdsModule {}
